module.exports = __webpack_public_path__ + "img/c01_unittoxotes_Normal_ua.1055539d.webp";